import { Injectable, NgZone } from '@angular/core'
import { UserAuthService } from './user-auth.service'
import { fromEvent, map, merge, Subject, switchMap, takeUntil, timer } from 'rxjs'
import { signOut } from 'aws-amplify/auth'
import { LoaderService } from './loader.service'
import { GtmTrackingService } from './gtm-tracking.service'
@Injectable({
  providedIn: 'root'
})
export class UserActiveService {
  inactivityTime = 3600000
  destroy$ = new Subject<void>()
  isLoggedIn: boolean | undefined

  constructor (private ngZone: NgZone, private authService: UserAuthService, private loaderService: LoaderService, private gtmService: GtmTrackingService) { }

  startMonitoring () {
    if (!this.isLoggedIn) {
      return
    }
    this.stopMonitoring()
    this.ngZone.runOutsideAngular(() => {
      const activityEvents = merge(
        fromEvent(document, 'mousemove').pipe(map(() => 'mousemove')),
        fromEvent(document, 'keydown').pipe(map(() => 'keydown')),
        fromEvent(document, 'click').pipe(map(() => 'click')),
        fromEvent(document, 'scroll').pipe(map(() => 'scroll')),
        fromEvent(document, 'touchstart').pipe(map(() => 'touchstart'))
      )
      activityEvents.pipe(
        switchMap(() => timer(this.inactivityTime)),
        takeUntil(this.destroy$)
      ).subscribe(() => {
        this.ngZone.run(() => this.signOut())
      })
    })
  }
  async signOut () {
    this.loaderService.show()
    try {
        await signOut({ global: true })
        this.gtmService.setOrGetClientTracking()
        this.gtmService.setClientTrackingWithLoggedInUser()
        this.authService.setUserId('')
        this.authService.setIdpUser(false)
        this.authService.deleteCookie('referrerUrl')
        this.authService.deleteCookie('previousPageUrl')
        this.authService.deleteCookie('isLoggedIn')
        this.authService.deleteCognitoCookies()
        window.location.reload()
    } catch (error) {
        console.error('Error during sign-out:', error)
    } finally {
      this.loaderService.hide()
      this.stopMonitoring()
    }
  }
  ngOnDestroy (): void {
    this.stopMonitoring()
  }
  stopMonitoring (): void {
    this.destroy$.next()
    this.destroy$.complete()
    this.destroy$ = new Subject<void>()
  }
  async userLoggedIn (): Promise<void> {
    try {
      this.isLoggedIn = true
      this.startMonitoring()
      const userEmail = await this.authService.getAuthorisedUserMail()
      if (!userEmail) {
        throw new Error('User email not found')
      }
      await this.gtmService.setClientTrackingWithLoggedInUser(userEmail)
    } catch (error) {
      this.isLoggedIn = false
      throw error
    }
  }
}
